import React from 'react';

const InputCell = ({ id, value, onChange, label, unit, isPercentage = false, step = "any" }) => {
    // Helper function to round values for display
    const roundForDisplay = (val) => {
        if (val == null || isNaN(val) || !isFinite(val)) return '';
        
        // Determine decimal places based on step or value magnitude
        let decimals = 2; // default
        if (step !== "any") {
            const stepNum = parseFloat(step);
            if (stepNum >= 1) decimals = 0;
            else if (stepNum >= 0.1) decimals = 1;
            else if (stepNum >= 0.01) decimals = 2;
            else decimals = 4;
        } else {
            // Auto-determine based on value magnitude
            if (Math.abs(val) >= 1000) decimals = 0;
            else if (Math.abs(val) >= 10) decimals = 1;
            else if (Math.abs(val) >= 0.01) decimals = 2;
            else decimals = 4;
        }
        
        return parseFloat(val.toFixed(decimals));
    };

    const displayValue = isPercentage ? roundForDisplay(value * 100) : roundForDisplay(value);
    
    return (
        <div className="grid grid-cols-2 gap-4 items-center py-2 px-3 hover:bg-gray-50 dark:hover:bg-gray-700/50 rounded-md">
            <label htmlFor={id} className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
            <div className="flex items-center">
                <input 
                    type="number" 
                    id={id} 
                    value={displayValue} 
                    onChange={e => onChange(id, isPercentage ? e.target.value / 100 : e.target.value)} 
                    className="w-full px-3 py-1.5 text-right bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm text-gray-900 dark:text-gray-100"
                    step={step}
                />
                <span className="text-sm text-gray-500 dark:text-gray-400 w-24 text-right pr-2">{unit}</span>
            </div>
        </div>
    );
};

export default InputCell; 